import styles from '../../../../styles/automation/index.module.scss';
import SmartInputDropdown from './SmartInputDropdown';
import SmartInputEditor from './SmartInputEditor';
import useSmartInputBox from './useSmartInputBox';

const SmartInputBox = ({
    variableTrigger = '${',
    placeholder = 'Type ${ to add variables',
    suggestions = [],
    descriptions = {},
    fileTrigger = '',
    fileSuggestions = [],
    fileDescriptions = {},
    formatFileInsertion,
    value = '',
    onChange,
    onBlur,
    onKeyDown: parentOnKeyDown,
    onMultiLinePaste,
    readOnly = false,
    disabled = false,
    ...inputBoxProps
}) => {
    const {
        containerRef,
        inputRef,
        dropdownListRef,
        dropdownPortalRef,
        displayValue,
        showDropdown,
        dropdownMode,
        dropdownPosition,
        activeLength,
        activeIndex,
        handleChange,
        handleBlur,
        handlePaste,
        handleKeyDown,
        insertToken,
        setSelectedIndex,
    } = useSmartInputBox({
        variableTrigger,
        suggestions,
        descriptions,
        fileTrigger,
        fileSuggestions,
        formatFileInsertion,
        value,
        onChange,
        onBlur,
        onKeyDown: parentOnKeyDown,
        onMultiLinePaste,
        readOnly,
        disabled,
    });

    return (
        <div ref={containerRef} className={styles.smartInputContainer}>
            <SmartInputEditor
                inputBoxProps={inputBoxProps}
                readOnly={readOnly}
                disabled={disabled}
                displayValue={displayValue}
                placeholder={placeholder}
                inputRef={inputRef}
                onChange={handleChange}
                onBlur={handleBlur}
                onPaste={handlePaste}
                onKeyDown={handleKeyDown}
            />
            <SmartInputDropdown
                show={showDropdown}
                activeLength={activeLength}
                dropdownPortalRef={dropdownPortalRef}
                dropdownPosition={dropdownPosition}
                dropdownMode={dropdownMode}
                suggestions={suggestions}
                fileSuggestions={fileSuggestions}
                activeIndex={activeIndex}
                descriptions={descriptions}
                fileDescriptions={fileDescriptions}
                dropdownListRef={dropdownListRef}
                insertToken={insertToken}
                setSelectedIndex={setSelectedIndex}
            />
        </div>
    );
};

export default SmartInputBox;
